const eReactFooter = React.createElement;
function NewsletterForm(props) {
  const [email, setEmail] = React.useState('');
  const [validEmail, setValidEmail] = React.useState(true);
  const [subscribed, setSubscribed] = React.useState(false);
  const handleSubmit = e => {
    e.preventDefault();
    if (email.match(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
      fetch("https://tlf-server-2023-oxh3p.ondigitalocean.app/zaius/add-to-list", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'accept': 'application/json'
        },
        body: JSON.stringify({
          "list_id": "newsletter",
          "email": email
        })
      }).then(data => data.json()).then(response => {
        response.updates[0].subscribed ? setSubscribed(true) : setSubscribed(false);
      });
    } else {
      setValidEmail(false);
    }
  };
  React.useEffect(() => {
    if (!validEmail) {
      // document.querySelector("#newsletter-input").classList.add('red')
    }
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, " ", !subscribed && /*#__PURE__*/React.createElement("form", {
    onSubmit: e => handleSubmit(e),
    className: "newsletterForm"
  }, /*#__PURE__*/React.createElement("input", {
    id: "newsletter-input",
    type: "text",
    name: "email",
    placeholder: "Email Address",
    value: email,
    onChange: event => setEmail(event.target.value),
    style: {
      backgroundColor: validEmail ? "" : "rgb(224, 123, 123)"
    }
  }), /*#__PURE__*/React.createElement("button", {
    "aria-label": "News letter sign up",
    className: "newsletterButton"
  }, /*#__PURE__*/React.createElement("svg", {
    width: "40px",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "33 81.9 67 50 33 18.1",
    fill: "none",
    stroke: "#fff",
    strokeWidth: "4"
  })))), subscribed && /*#__PURE__*/React.createElement("div", {
    className: "alert alert-success"
  }, "You have been subscribed!"));
}
function ReactFooter() {
  const [width, setWidth] = React.useState(window.innerWidth);
  React.useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("footer", null, /*#__PURE__*/React.createElement("div", {
    className: "flex colabsibles"
  }, /*#__PURE__*/React.createElement("section", {
    className: "flex-content padding_1x"
  }, /*#__PURE__*/React.createElement(Collapsible, {
    width: width,
    title: "SHOP",
    maxWidth: 950
  }, /*#__PURE__*/React.createElement("li", null, " ", /*#__PURE__*/React.createElement("div", {
    className: "subHead"
  }, /*#__PURE__*/React.createElement("a", {
    className: "collabsible-item",
    href: "/collections/mens"
  }, "Men"))), /*#__PURE__*/React.createElement("li", null, " ", /*#__PURE__*/React.createElement("div", {
    className: "subHead"
  }, /*#__PURE__*/React.createElement("a", {
    className: "collabsible-item",
    href: "/collections/womens"
  }, "Women"))), /*#__PURE__*/React.createElement("li", null, " ", /*#__PURE__*/React.createElement("div", {
    className: "subHead"
  }, /*#__PURE__*/React.createElement("a", {
    className: "collabsible-item",
    href: "/products/tlf-gift-card"
  }, "Gift Cards"))), /*#__PURE__*/React.createElement("li", null, " ", /*#__PURE__*/React.createElement("div", {
    className: "subHead"
  }, /*#__PURE__*/React.createElement("a", {
    className: "collabsible-item",
    href: "/pages/pay-later-try-before-you-buy"
  }, "Buy Now Pay Later"))), /*#__PURE__*/React.createElement("li", null, " ", /*#__PURE__*/React.createElement("div", {
    className: "subHead"
  }, /*#__PURE__*/React.createElement("a", {
    className: "collabsible-item",
    href: "/pages/rewards"
  }, "Rewards"))))), /*#__PURE__*/React.createElement("section", {
    className: "flex-content padding_1x"
  }, /*#__PURE__*/React.createElement(Collapsible, {
    width: width,
    title: "ABOUT TLF",
    maxWidth: 950
  }, /*#__PURE__*/React.createElement("li", null, " ", /*#__PURE__*/React.createElement("div", {
    className: "subHead"
  }, /*#__PURE__*/React.createElement("a", {
    className: "collabsible-item",
    href: "/pages/about-us"
  }, "About us"))), /*#__PURE__*/React.createElement("li", null, " ", /*#__PURE__*/React.createElement("div", {
    className: "subHead"
  }, /*#__PURE__*/React.createElement("a", {
    className: "collabsible-item",
    href: "/pages/affiliates"
  }, "Influencers"))), /*#__PURE__*/React.createElement("li", null, " ", /*#__PURE__*/React.createElement("div", {
    className: "subHead"
  }, /*#__PURE__*/React.createElement("a", {
    className: "collabsible-item",
    href: "/pages/apparel-fabric-technology-innovation"
  }, "Technologies"))), /*#__PURE__*/React.createElement("li", null, " ", /*#__PURE__*/React.createElement("div", {
    className: "subHead"
  }, " ", /*#__PURE__*/React.createElement("a", {
    className: "collabsible-item",
    href: "/blogs/news"
  }, "Blog"))))), /*#__PURE__*/React.createElement("section", {
    className: "flex-content padding_1x"
  }, /*#__PURE__*/React.createElement(Collapsible, {
    width: width,
    title: "HELP",
    maxWidth: 950
  }, /*#__PURE__*/React.createElement("li", null, "  ", /*#__PURE__*/React.createElement("div", {
    className: "subHead"
  }, /*#__PURE__*/React.createElement("a", {
    className: "collabsible-item",
    href: "https://helpdesk.tlfapparel.com/hc/en-us"
  }, "FAQ"))), /*#__PURE__*/React.createElement("li", null, " ", /*#__PURE__*/React.createElement("div", {
    className: "subHead"
  }, /*#__PURE__*/React.createElement("a", {
    className: "collabsible-item",
    href: "/pages/order-lookup"
  }, "Order Status"))), /*#__PURE__*/React.createElement("li", null, " ", /*#__PURE__*/React.createElement("div", {
    className: "subHead"
  }, /*#__PURE__*/React.createElement("a", {
    className: "collabsible-item",
    href: "https://tlfapparel.zendesk.com/hc/en-us#contactsection"
  }, "Contact Us"))), /*#__PURE__*/React.createElement("li", null, " ", /*#__PURE__*/React.createElement("div", {
    className: "subHead"
  }, /*#__PURE__*/React.createElement("a", {
    className: "collabsible-item",
    href: "https://tlfapparel.loopreturns.com/#/"
  }, "Returns"))), /*#__PURE__*/React.createElement("li", {
    className: "hide-on-large-screen"
  }, " ", /*#__PURE__*/React.createElement("div", {
    className: "subHead"
  }, /*#__PURE__*/React.createElement("a", {
    className: "collabsible-item",
    href: "https://helpdesk.tlfapparel.com/hc/en-us/articles/4411116828813-Refund-Policy"
  }, "Refund Policy"))), /*#__PURE__*/React.createElement("li", {
    className: "hide-on-large-screen"
  }, " ", /*#__PURE__*/React.createElement("div", {
    className: "subHead"
  }, /*#__PURE__*/React.createElement("a", {
    className: "collabsible-item",
    href: "/pages/accessibility"
  }, "Accessibility"))), /*#__PURE__*/React.createElement("li", {
    className: "hide-on-large-screen"
  }, " ", /*#__PURE__*/React.createElement("div", {
    className: "subHead"
  }, /*#__PURE__*/React.createElement("a", {
    className: "collabsible-item",
    href: "https://terms.pscr.pt/legal/shop/tlfapparel/privacy_policy"
  }, "Privacy Policy"))), /*#__PURE__*/React.createElement("li", {
    className: "hide-on-large-screen"
  }, " ", /*#__PURE__*/React.createElement("div", {
    className: "subHead"
  }, /*#__PURE__*/React.createElement("a", {
    className: "collabsible-item",
    href: "https://terms.pscr.pt/legal/shop/tlfapparel/terms_of_service"
  }, "Terms and Conditions"))), /*#__PURE__*/React.createElement("li", null, " ", /*#__PURE__*/React.createElement("div", {
    className: "subHead"
  }, " ", /*#__PURE__*/React.createElement("a", {
    className: "collabsible-item",
    href: "/pages/sitemap"
  }, "Sitemap"))))), /*#__PURE__*/React.createElement("section", {
    className: "flex-content padding_1x"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mobileDownload"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "mobileTitle"
  }, "DOWNLOAD OUR APP"), /*#__PURE__*/React.createElement("div", {
    className: "mobileShow"
  }, /*#__PURE__*/React.createElement("a", {
    className: "appLink",
    href: "https://tlfapparel.page.link/app",
    "aria-label": "Click to download the TLF app"
  }, /*#__PURE__*/React.createElement("svg", {
    width: "41",
    height: "51",
    viewBox: "0 0 41 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0517 26.8474C34.0765 24.9125 34.5867 23.0154 35.5348 21.3325C36.483 19.6496 37.8383 18.2356 39.4747 17.2222C38.4351 15.7266 37.0637 14.4958 35.4694 13.6275C33.8751 12.7592 32.1017 12.2774 30.2902 12.2203C26.4259 11.8117 22.6796 14.5497 20.7105 14.5497C18.7032 14.5497 15.6713 12.2609 12.4065 12.3285C10.2948 12.3972 8.23671 13.0159 6.43284 14.1241C4.62897 15.2323 3.14083 16.7924 2.11342 18.6522C-2.33713 26.4145 0.982576 37.8224 5.24582 44.0968C7.37882 47.1692 9.87167 50.6012 13.1335 50.4795C16.3254 50.3461 17.5176 48.4291 21.3705 48.4291C25.1876 48.4291 26.3061 50.4795 29.6341 50.4021C33.0592 50.3461 35.2172 47.316 37.2753 44.2145C38.8079 42.0253 39.9872 39.6058 40.7695 37.0455C38.7797 36.1977 37.0816 34.7786 35.8869 32.965C34.6923 31.1515 34.0541 29.0239 34.0517 26.8474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7689 8.0919C29.6364 5.83351 30.5564 2.93072 30.3336 0C27.4805 0.301875 24.845 1.67554 22.9523 3.84728C22.0269 4.90824 21.3181 6.14252 20.8665 7.47958C20.4149 8.81664 20.2293 10.2303 20.3204 11.6396C21.7474 11.6544 23.1592 11.3428 24.4495 10.7283C25.7397 10.1138 26.8746 9.21234 27.7689 8.0919Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("a", {
    className: "appLink",
    href: "https://tlfapparel.page.link/app",
    "aria-label": "Click to download the TLF app"
  }, /*#__PURE__*/React.createElement("svg", {
    width: "41",
    height: "51",
    viewBox: "0 0 41 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.83 0.0405092C10.7062 0.0630092 10.5787 0.0855092 10.47 0.160509C10.0312 0.456759 9.93375 1.07176 10.23 1.51051L12.3 4.60051C9.10125 6.29551 6.71625 9.11176 5.94 12.4905H32.46C31.6837 9.11176 29.2987 6.29551 26.1 4.60051L28.17 1.51051C28.4662 1.07176 28.3687 0.456759 27.93 0.160509C27.4875 -0.135741 26.8762 -0.00824083 26.58 0.430509L24.3 3.79051C22.7175 3.21301 21 2.89051 19.2 2.89051C17.4 2.89051 15.6825 3.21301 14.1 3.79051L11.82 0.430509C11.5987 0.100509 11.1975 -0.0307408 10.83 0.0405092ZM13.92 7.69051C14.715 7.69051 15.36 8.33551 15.36 9.13051C15.36 9.92926 14.715 10.5705 13.92 10.5705C13.1212 10.5705 12.48 9.92926 12.48 9.13051C12.48 8.33551 13.1212 7.69051 13.92 7.69051ZM24.48 7.69051C25.2787 7.69051 25.92 8.33551 25.92 9.13051C25.92 9.92926 25.2787 10.5705 24.48 10.5705C23.685 10.5705 23.04 9.92926 23.04 9.13051C23.04 8.33551 23.685 7.69051 24.48 7.69051ZM2.88 14.4105C1.29 14.4105 0 15.7005 0 17.2905V30.7305C0 32.3205 1.29 33.6105 2.88 33.6105C3.2175 33.6105 3.54 33.5393 3.84 33.4305V14.5905C3.54 14.4818 3.2175 14.4105 2.88 14.4105ZM5.76 14.4105V35.5305C5.76 37.1168 7.05375 38.4105 8.64 38.4105H29.76C31.3462 38.4105 32.64 37.1168 32.64 35.5305V14.4105H5.76ZM35.52 14.4105C35.1825 14.4105 34.86 14.4818 34.56 14.5905V33.4305C34.86 33.5355 35.1825 33.6105 35.52 33.6105C37.11 33.6105 38.4 32.3205 38.4 30.7305V17.2905C38.4 15.7005 37.11 14.4105 35.52 14.4105ZM9.6 40.3305V44.1705C9.6 46.2893 11.3212 48.0105 13.44 48.0105C15.5587 48.0105 17.28 46.2893 17.28 44.1705V40.3305H9.6ZM21.12 40.3305V44.1705C21.12 46.2893 22.8412 48.0105 24.96 48.0105C27.0787 48.0105 28.8 46.2893 28.8 44.1705V40.3305H21.12Z",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("h1", {
    className: "socialTitle"
  }, "FOLLOW US"), /*#__PURE__*/React.createElement("ul", {
    className: "socialIcons"
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    href: "https://www.instagram.com/tlfapparel/",
    title: "TLF Apparel on Instagram"
  }, /*#__PURE__*/React.createElement("svg", {
    "aria-hidden": "true",
    focusable: "false",
    role: "presentation",
    className: "icon icon-instagram",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    d: "M16 3.094c4.206 0 4.7.019 6.363.094 1.538.069 2.369.325 2.925.544.738.287 1.262.625 1.813 1.175s.894 1.075 1.175 1.813c.212.556.475 1.387.544 2.925.075 1.662.094 2.156.094 6.363s-.019 4.7-.094 6.363c-.069 1.538-.325 2.369-.544 2.925-.288.738-.625 1.262-1.175 1.813s-1.075.894-1.813 1.175c-.556.212-1.387.475-2.925.544-1.663.075-2.156.094-6.363.094s-4.7-.019-6.363-.094c-1.537-.069-2.369-.325-2.925-.544-.737-.288-1.263-.625-1.813-1.175s-.894-1.075-1.175-1.813c-.212-.556-.475-1.387-.544-2.925-.075-1.663-.094-2.156-.094-6.363s.019-4.7.094-6.363c.069-1.537.325-2.369.544-2.925.287-.737.625-1.263 1.175-1.813s1.075-.894 1.813-1.175c.556-.212 1.388-.475 2.925-.544 1.662-.081 2.156-.094 6.363-.094zm0-2.838c-4.275 0-4.813.019-6.494.094-1.675.075-2.819.344-3.819.731-1.037.4-1.913.944-2.788 1.819S1.486 4.656 1.08 5.688c-.387 1-.656 2.144-.731 3.825-.075 1.675-.094 2.213-.094 6.488s.019 4.813.094 6.494c.075 1.675.344 2.819.731 3.825.4 1.038.944 1.913 1.819 2.788s1.756 1.413 2.788 1.819c1 .387 2.144.656 3.825.731s2.213.094 6.494.094 4.813-.019 6.494-.094c1.675-.075 2.819-.344 3.825-.731 1.038-.4 1.913-.944 2.788-1.819s1.413-1.756 1.819-2.788c.387-1 .656-2.144.731-3.825s.094-2.212.094-6.494-.019-4.813-.094-6.494c-.075-1.675-.344-2.819-.731-3.825-.4-1.038-.944-1.913-1.819-2.788s-1.756-1.413-2.788-1.819c-1-.387-2.144-.656-3.825-.731C20.812.275 20.275.256 16 .256z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    d: "M16 7.912a8.088 8.088 0 0 0 0 16.175c4.463 0 8.087-3.625 8.087-8.088s-3.625-8.088-8.088-8.088zm0 13.338a5.25 5.25 0 1 1 0-10.5 5.25 5.25 0 1 1 0 10.5zM26.294 7.594a1.887 1.887 0 1 1-3.774.002 1.887 1.887 0 0 1 3.774-.003z"
  })))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    href: "https://facebook.com/TLFApparel/",
    title: "TLF Apparel on Facebook"
  }, /*#__PURE__*/React.createElement("svg", {
    "aria-hidden": "true",
    focusable: "false",
    role: "presentation",
    className: "icon icon-facebook",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    d: "M18.56 31.36V17.28h4.48l.64-5.12h-5.12v-3.2c0-1.28.64-2.56 2.56-2.56h2.56V1.28H19.2c-3.84 0-7.04 2.56-7.04 7.04v3.84H7.68v5.12h4.48v14.08h6.4z"
  })))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    href: "https://twitter.com/tlfapparel",
    title: "TLF Apparel on Twitter"
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-twitter",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
  })))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    href: "https://www.youtube.com/channel/UCe2oLHfdiNMhwujUAlI_bwA?sub_confirmation=1",
    title: "TLF Apparel on YouTube"
  }, /*#__PURE__*/React.createElement("svg", {
    "aria-hidden": "true",
    focusable: "false",
    role: "presentation",
    className: "icon icon-youtube",
    viewBox: "0 0 21 20"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    d: "M-.196 15.803q0 1.23.812 2.092t1.977.861h14.946q1.165 0 1.977-.861t.812-2.092V3.909q0-1.23-.82-2.116T17.539.907H2.593q-1.148 0-1.969.886t-.82 2.116v11.894zm7.465-2.149V6.058q0-.115.066-.18.049-.016.082-.016l.082.016 7.153 3.806q.066.066.066.164 0 .066-.066.131l-7.153 3.806q-.033.033-.066.033-.066 0-.098-.033-.066-.066-.066-.131z"
  })))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    href: "https://www.pinterest.com/tlfapparel/",
    title: "TLF Apparel on Pinterest"
  }, /*#__PURE__*/React.createElement("svg", {
    "aria-hidden": "true",
    focusable: "false",
    role: "presentation",
    className: "icon icon-pinterest",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    d: "M27.52 9.6c-.64-5.76-6.4-8.32-12.8-7.68-4.48.64-9.6 4.48-9.6 10.24 0 3.2.64 5.76 3.84 6.4 1.28-2.56-.64-3.2-.64-4.48-1.28-7.04 8.32-12.16 13.44-7.04 3.2 3.84 1.28 14.08-4.48 13.44-5.12-1.28 2.56-9.6-1.92-11.52-3.2-1.28-5.12 4.48-3.84 7.04-1.28 4.48-3.2 8.96-1.92 15.36 2.56-1.92 3.84-5.76 4.48-9.6 1.28.64 1.92 1.92 3.84 1.92 6.4-.64 10.24-7.68 9.6-14.08z"
  })))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    href: "https://www.tiktok.com/@tlfapparel",
    title: "TLF Apparel on TikTok"
  }, /*#__PURE__*/React.createElement("svg", {
    className: "icon",
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6282 5.81875V8.62384C19.6282 8.62384 18.3149 8.57177 17.3423 8.3215C15.9848 7.97146 15.1118 7.4346 15.1118 7.4346C15.1118 7.4346 14.5095 7.05174 14.4608 7.02462V14.42C14.4608 14.8317 14.3493 15.8604 14.0096 16.7175C13.5662 17.8398 12.8818 18.5762 12.7559 18.7267C12.7559 18.7267 11.9231 19.7221 10.455 20.3925C9.13182 20.9971 7.96966 20.9818 7.62182 20.9971C7.62182 20.9971 5.61331 21.0777 3.80511 19.8888L3.79609 19.8823C3.60518 19.6952 3.42548 19.4977 3.25787 19.2907C2.68085 18.5788 2.32715 17.737 2.23827 17.4968C2.23812 17.4958 2.23812 17.4947 2.23827 17.4937C2.09526 17.0763 1.79479 16.0739 1.83585 15.103C1.90848 13.39 2.504 12.3386 2.66145 12.0752C3.07845 11.3569 3.6208 10.7142 4.26438 10.1758C4.8323 9.71119 5.47601 9.34152 6.16913 9.08195C6.9184 8.77718 7.72075 8.61383 8.53314 8.60065V11.4403C8.53314 11.4403 7.04706 10.9634 5.85783 11.8078C5.02637 12.4327 4.58515 13.0422 4.45521 14.1308C4.4498 14.9319 4.65237 16.0656 5.76354 16.8217C5.89317 16.9048 6.0204 16.9786 6.14522 17.0431C6.33934 17.2984 6.57561 17.5209 6.84449 17.7016C7.92996 18.3968 8.83947 18.4454 10.0025 17.9938C10.7781 17.6919 11.3618 17.0116 11.6325 16.2577C11.8026 15.7869 11.8004 15.313 11.8004 14.823V0.882812H14.5072C14.6191 1.52644 14.9286 2.44266 15.747 3.35012C16.0753 3.69276 16.4451 3.9957 16.8483 4.25234C16.9674 4.37704 17.5764 4.99354 18.3582 5.37201C18.7625 5.56765 19.1886 5.71754 19.6282 5.81875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.16602 16.6211V16.6233L1.23398 16.8075C1.22618 16.786 1.20092 16.7209 1.16602 16.6211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1709 9.07969C5.47779 9.33925 4.83407 9.70893 4.26615 10.1735C3.62237 10.7132 3.08015 11.3572 2.66367 12.0769C2.50622 12.3394 1.91071 13.3917 1.83807 15.1047C1.79702 16.0756 2.09748 17.078 2.2405 17.4954C2.24034 17.4964 2.24034 17.4975 2.2405 17.4985C2.33073 17.7365 2.68307 18.5783 3.26009 19.2924C3.4277 19.4994 3.60741 19.6969 3.79831 19.884C3.18664 19.4737 2.64113 18.9777 2.17959 18.4121C1.60754 17.7063 1.25474 16.8732 1.1627 16.6273C1.16259 16.6256 1.16259 16.6238 1.1627 16.6221V16.619C1.01924 16.202 0.717871 15.1992 0.759828 14.227C0.832463 12.514 1.42798 11.4626 1.58543 11.1992C2.00178 10.4794 2.54402 9.83538 3.18791 9.29583C3.75571 8.83105 4.39946 8.46136 5.09266 8.20197C5.52504 8.02798 5.97547 7.89963 6.43618 7.81912C7.13048 7.70158 7.83959 7.69139 8.53718 7.78893V8.59839C7.72402 8.61129 6.92089 8.77465 6.1709 9.07969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5123 0.880339H11.8054V14.8209C11.8054 15.311 11.8054 15.7835 11.6376 16.2556C11.3642 17.0091 10.7826 17.6895 10.0076 17.9914C8.84405 18.4447 7.93453 18.3944 6.84952 17.6991C6.58017 17.5192 6.34329 17.2975 6.14844 17.0428C7.07284 17.521 7.90024 17.5127 8.92525 17.1137C9.69987 16.8118 10.2823 16.1314 10.5548 15.3775C10.7253 14.9067 10.7231 14.4328 10.7231 13.9432V0H14.4608C14.4608 0 14.4189 0.346535 14.5123 0.880339ZM19.631 5.04051V5.81627C19.1922 5.71491 18.7668 5.56502 18.3633 5.36954C17.5814 4.99107 16.9724 4.37457 16.8533 4.24987C16.9915 4.33787 17.1349 4.41793 17.2828 4.48964C18.2333 4.94994 19.1695 5.08733 19.631 5.04051Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    href: "https://www.threads.net/@tlfapparel?igshid=MzRlODBiNWFlZA==",
    title: "TLF Apparel on Threads"
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-twitter",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.5 235.7c2.2 .9 4.2 1.9 6.3 2.8c29.2 14.1 50.6 35.2 61.8 61.4c15.7 36.5 17.2 95.8-30.3 143.2c-36.2 36.2-80.3 52.5-142.6 53h-.3c-70.2-.5-124.1-24.1-160.4-70.2c-32.3-41-48.9-98.1-49.5-169.6V256v-.2C17 184.3 33.6 127.2 65.9 86.2C102.2 40.1 156.2 16.5 226.4 16h.3c70.3 .5 124.9 24 162.3 69.9c18.4 22.7 32 50 40.6 81.7l-40.4 10.8c-7.1-25.8-17.8-47.8-32.2-65.4c-29.2-35.8-73-54.2-130.5-54.6c-57 .5-100.1 18.8-128.2 54.4C72.1 146.1 58.5 194.3 58 256c.5 61.7 14.1 109.9 40.3 143.3c28 35.6 71.2 53.9 128.2 54.4c51.4-.4 85.4-12.6 113.7-40.9c32.3-32.2 31.7-71.8 21.4-95.9c-6.1-14.2-17.1-26-31.9-34.9c-3.7 26.9-11.8 48.3-24.7 64.8c-17.1 21.8-41.4 33.6-72.7 35.3c-23.6 1.3-46.3-4.4-63.9-16c-20.8-13.8-33-34.8-34.3-59.3c-2.5-48.3 35.7-83 95.2-86.4c21.1-1.2 40.9-.3 59.2 2.8c-2.4-14.8-7.3-26.6-14.6-35.2c-10-11.7-25.6-17.7-46.2-17.8H227c-16.6 0-39 4.6-53.3 26.3l-34.4-23.6c19.2-29.1 50.3-45.1 87.8-45.1h.8c62.6 .4 99.9 39.5 103.7 107.7l-.2 .2zm-156 68.8c1.3 25.1 28.4 36.8 54.6 35.3c25.6-1.4 54.6-11.4 59.5-73.2c-13.2-2.9-27.8-4.4-43.4-4.4c-4.8 0-9.6 .1-14.4 .4c-42.9 2.4-57.2 23.2-56.2 41.8l-.1 .1z"
  }))))), /*#__PURE__*/React.createElement("h1", {
    className: "newsletterTitle"
  }, "SIGN UP TO OUR NEWSLETTER"), /*#__PURE__*/React.createElement("div", {
    className: "klaviyo-form-XSEes8"
  }), /*#__PURE__*/React.createElement("div", {
    className: "payments"
  }, /*#__PURE__*/React.createElement("svg", {
    className: "payment-icon",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    viewBox: "0 0 38 24",
    width: "38",
    height: "24",
    "aria-labelledby": "pi-amazon"
  }, /*#__PURE__*/React.createElement("title", {
    id: "pi-amazon"
  }, "Amazon"), /*#__PURE__*/React.createElement("path", {
    d: "M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z",
    fill: "#000",
    fillRule: "nonzero",
    opacity: ".07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.26 16.23c-1.697 1.48-4.157 2.27-6.275 2.27-2.97 0-5.644-1.3-7.666-3.463-.16-.17-.018-.402.173-.27 2.183 1.504 4.882 2.408 7.67 2.408 1.88 0 3.95-.46 5.85-1.416.288-.145.53.222.248.47v.001zm.706-.957c-.216-.328-1.434-.155-1.98-.078-.167.024-.193-.148-.043-.27.97-.81 2.562-.576 2.748-.305.187.272-.047 2.16-.96 3.063-.14.138-.272.064-.21-.12.205-.604.664-1.96.446-2.29h-.001z",
    fill: "#F90",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.814 15.291c-.574-.498-.676-.73-.993-1.205-.947 1.012-1.618 1.315-2.85 1.315-1.453 0-2.587-.938-2.587-2.818 0-1.467.762-2.467 1.844-2.955.94-.433 2.25-.51 3.25-.628v-.235c0-.43.033-.94-.208-1.31-.212-.333-.616-.47-.97-.47-.66 0-1.25.353-1.392 1.085-.03.163-.144.323-.3.33l-1.677-.187c-.14-.033-.296-.153-.257-.38.386-2.125 2.223-2.766 3.867-2.766.84 0 1.94.234 2.604.9.842.82.762 1.918.762 3.11v2.818c0 .847.335 1.22.65 1.676.113.164.138.36-.003.482-.353.308-.98.88-1.326 1.2a.367.367 0 0 1-.414.038zm-1.659-2.533c.34-.626.323-1.214.323-1.918v-.392c-1.25 0-2.57.28-2.57 1.82 0 .782.386 1.31 1.05 1.31.487 0 .922-.312 1.197-.82z",
    fill: "#221F1F"
  })), /*#__PURE__*/React.createElement("svg", {
    className: "payment-icon",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    viewBox: "0 0 38 24",
    width: "38",
    height: "24",
    "aria-labelledby": "pi-american_express"
  }, /*#__PURE__*/React.createElement("title", {
    id: "pi-american_express"
  }, "American Express"), /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M35,0 L3,0 C1.3,0 0,1.3 0,3 L0,21 C0,22.7 1.4,24 3,24 L35,24 C36.7,24 38,22.7 38,21 L38,3 C38,1.3 36.6,0 35,0 Z",
    opacity: ".07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006FCF",
    d: "M35,1 C36.1,1 37,1.9 37,3 L37,21 C37,22.1 36.1,23 35,23 L3,23 C1.9,23 1,22.1 1,21 L1,3 C1,1.9 1.9,1 3,1 L35,1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.971,10.268 L9.745,12.144 L8.203,12.144 L8.971,10.268 Z M25.046,10.346 L22.069,10.346 L22.069,11.173 L24.998,11.173 L24.998,12.412 L22.075,12.412 L22.075,13.334 L25.052,13.334 L25.052,14.073 L27.129,11.828 L25.052,9.488 L25.046,10.346 L25.046,10.346 Z M10.983,8.006 L14.978,8.006 L15.865,9.941 L16.687,8 L27.057,8 L28.135,9.19 L29.25,8 L34.013,8 L30.494,11.852 L33.977,15.68 L29.143,15.68 L28.065,14.49 L26.94,15.68 L10.03,15.68 L9.536,14.49 L8.406,14.49 L7.911,15.68 L4,15.68 L7.286,8 L10.716,8 L10.983,8.006 Z M19.646,9.084 L17.407,9.084 L15.907,12.62 L14.282,9.084 L12.06,9.084 L12.06,13.894 L10,9.084 L8.007,9.084 L5.625,14.596 L7.18,14.596 L7.674,13.406 L10.27,13.406 L10.764,14.596 L13.484,14.596 L13.484,10.661 L15.235,14.602 L16.425,14.602 L18.165,10.673 L18.165,14.603 L19.623,14.603 L19.647,9.083 L19.646,9.084 Z M28.986,11.852 L31.517,9.084 L29.695,9.084 L28.094,10.81 L26.546,9.084 L20.652,9.084 L20.652,14.602 L26.462,14.602 L28.076,12.864 L29.624,14.602 L31.499,14.602 L28.987,11.852 L28.986,11.852 Z"
  }))), /*#__PURE__*/React.createElement("svg", {
    className: "payment-icon",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    width: "38",
    height: "24",
    viewBox: "0 0 165.521 105.965",
    "aria-labelledby": "pi-apple_pay"
  }, /*#__PURE__*/React.createElement("title", {
    id: "pi-apple_pay"
  }, "Apple Pay"), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M150.698 0H14.823c-.566 0-1.133 0-1.698.003-.477.004-.953.009-1.43.022-1.039.028-2.087.09-3.113.274a10.51 10.51 0 0 0-2.958.975 9.932 9.932 0 0 0-4.35 4.35 10.463 10.463 0 0 0-.975 2.96C.113 9.611.052 10.658.024 11.696a70.22 70.22 0 0 0-.022 1.43C0 13.69 0 14.256 0 14.823v76.318c0 .567 0 1.132.002 1.699.003.476.009.953.022 1.43.028 1.036.09 2.084.275 3.11a10.46 10.46 0 0 0 .974 2.96 9.897 9.897 0 0 0 1.83 2.52 9.874 9.874 0 0 0 2.52 1.83c.947.483 1.917.79 2.96.977 1.025.183 2.073.245 3.112.273.477.011.953.017 1.43.02.565.004 1.132.004 1.698.004h135.875c.565 0 1.132 0 1.697-.004.476-.002.952-.009 1.431-.02 1.037-.028 2.085-.09 3.113-.273a10.478 10.478 0 0 0 2.958-.977 9.955 9.955 0 0 0 4.35-4.35c.483-.947.789-1.917.974-2.96.186-1.026.246-2.074.274-3.11.013-.477.02-.954.022-1.43.004-.567.004-1.132.004-1.699V14.824c0-.567 0-1.133-.004-1.699a63.067 63.067 0 0 0-.022-1.429c-.028-1.038-.088-2.085-.274-3.112a10.4 10.4 0 0 0-.974-2.96 9.94 9.94 0 0 0-4.35-4.35A10.52 10.52 0 0 0 156.939.3c-1.028-.185-2.076-.246-3.113-.274a71.417 71.417 0 0 0-1.431-.022C151.83 0 151.263 0 150.698 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M150.698 3.532l1.672.003c.452.003.905.008 1.36.02.793.022 1.719.065 2.583.22.75.135 1.38.34 1.984.648a6.392 6.392 0 0 1 2.804 2.807c.306.6.51 1.226.645 1.983.154.854.197 1.783.218 2.58.013.45.019.9.02 1.36.005.557.005 1.113.005 1.671v76.318c0 .558 0 1.114-.004 1.682-.002.45-.008.9-.02 1.35-.022.796-.065 1.725-.221 2.589a6.855 6.855 0 0 1-.645 1.975 6.397 6.397 0 0 1-2.808 2.807c-.6.306-1.228.511-1.971.645-.881.157-1.847.2-2.574.22-.457.01-.912.017-1.379.019-.555.004-1.113.004-1.669.004H14.801c-.55 0-1.1 0-1.66-.004a74.993 74.993 0 0 1-1.35-.018c-.744-.02-1.71-.064-2.584-.22a6.938 6.938 0 0 1-1.986-.65 6.337 6.337 0 0 1-1.622-1.18 6.355 6.355 0 0 1-1.178-1.623 6.935 6.935 0 0 1-.646-1.985c-.156-.863-.2-1.788-.22-2.578a66.088 66.088 0 0 1-.02-1.355l-.003-1.327V14.474l.002-1.325a66.7 66.7 0 0 1 .02-1.357c.022-.792.065-1.717.222-2.587a6.924 6.924 0 0 1 .646-1.981c.304-.598.7-1.144 1.18-1.623a6.386 6.386 0 0 1 1.624-1.18 6.96 6.96 0 0 1 1.98-.646c.865-.155 1.792-.198 2.586-.22.452-.012.905-.017 1.354-.02l1.677-.003h135.875"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M43.508 35.77c1.404-1.755 2.356-4.112 2.105-6.52-2.054.102-4.56 1.355-6.012 3.112-1.303 1.504-2.456 3.959-2.156 6.266 2.306.2 4.61-1.152 6.063-2.858"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M45.587 39.079c-3.35-.2-6.196 1.9-7.795 1.9-1.6 0-4.049-1.8-6.698-1.751-3.447.05-6.645 2-8.395 5.1-3.598 6.2-.95 15.4 2.55 20.45 1.699 2.5 3.747 5.25 6.445 5.151 2.55-.1 3.549-1.65 6.647-1.65 3.097 0 3.997 1.65 6.696 1.6 2.798-.05 4.548-2.5 6.247-5 1.95-2.85 2.747-5.6 2.797-5.75-.05-.05-5.396-2.101-5.446-8.251-.05-5.15 4.198-7.6 4.398-7.751-2.399-3.548-6.147-3.948-7.447-4.048"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M78.973 32.11c7.278 0 12.347 5.017 12.347 12.321 0 7.33-5.173 12.373-12.529 12.373h-8.058V69.62h-5.822V32.11h14.062zm-8.24 19.807h6.68c5.07 0 7.954-2.729 7.954-7.46 0-4.73-2.885-7.434-7.928-7.434h-6.706v14.894z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M92.764 61.847c0-4.809 3.665-7.564 10.423-7.98l7.252-.442v-2.08c0-3.04-2.001-4.704-5.562-4.704-2.938 0-5.07 1.507-5.51 3.82h-5.252c.157-4.86 4.731-8.395 10.918-8.395 6.654 0 10.995 3.483 10.995 8.89v18.663h-5.38v-4.497h-.13c-1.534 2.937-4.914 4.782-8.579 4.782-5.406 0-9.175-3.222-9.175-8.057zm17.675-2.417v-2.106l-6.472.416c-3.64.234-5.536 1.585-5.536 3.95 0 2.288 1.975 3.77 5.068 3.77 3.95 0 6.94-2.522 6.94-6.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M120.975 79.652v-4.496c.364.051 1.247.103 1.715.103 2.573 0 4.029-1.09 4.913-3.899l.52-1.663-9.852-27.293h6.082l6.863 22.146h.13l6.862-22.146h5.927l-10.216 28.67c-2.34 6.577-5.017 8.735-10.683 8.735-.442 0-1.872-.052-2.261-.157z"
  })))), /*#__PURE__*/React.createElement("svg", {
    className: "payment-icon",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    viewBox: "0 0 38 24",
    width: "38",
    height: "24",
    "aria-labelledby": "pi-google_pay"
  }, /*#__PURE__*/React.createElement("title", {
    id: "pi-google_pay"
  }, "Google Pay"), /*#__PURE__*/React.createElement("path", {
    d: "M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z",
    fill: "#000",
    opacity: ".07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.093 11.976v3.2h-1.018v-7.9h2.691a2.447 2.447 0 0 1 1.747.692 2.28 2.28 0 0 1 .11 3.224l-.11.116c-.47.447-1.098.69-1.747.674l-1.673-.006zm0-3.732v2.788h1.698c.377.012.741-.135 1.005-.404a1.391 1.391 0 0 0-1.005-2.354l-1.698-.03zm6.484 1.348c.65-.03 1.286.188 1.778.613.445.43.682 1.03.65 1.649v3.334h-.969v-.766h-.049a1.93 1.93 0 0 1-1.673.931 2.17 2.17 0 0 1-1.496-.533 1.667 1.667 0 0 1-.613-1.324 1.606 1.606 0 0 1 .613-1.336 2.746 2.746 0 0 1 1.698-.515c.517-.02 1.03.093 1.49.331v-.208a1.134 1.134 0 0 0-.417-.901 1.416 1.416 0 0 0-.98-.368 1.545 1.545 0 0 0-1.319.717l-.895-.564a2.488 2.488 0 0 1 2.182-1.06zM23.29 13.52a.79.79 0 0 0 .337.662c.223.176.5.269.785.263.429-.001.84-.17 1.146-.472.305-.286.478-.685.478-1.103a2.047 2.047 0 0 0-1.324-.374 1.716 1.716 0 0 0-1.03.294.883.883 0 0 0-.392.73zm9.286-3.75l-3.39 7.79h-1.048l1.281-2.728-2.224-5.062h1.103l1.612 3.885 1.569-3.885h1.097z",
    fill: "#5F6368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.986 11.284c0-.308-.024-.616-.073-.92h-4.29v1.747h2.451a2.096 2.096 0 0 1-.9 1.373v1.134h1.464a4.433 4.433 0 0 0 1.348-3.334z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.629 15.721a4.352 4.352 0 0 0 3.01-1.097l-1.466-1.14a2.752 2.752 0 0 1-4.094-1.44H5.577v1.17a4.53 4.53 0 0 0 4.052 2.507z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.079 12.05a2.709 2.709 0 0 1 0-1.735v-1.17H5.577a4.505 4.505 0 0 0 0 4.075l1.502-1.17z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.629 8.44a2.452 2.452 0 0 1 1.74.68l1.3-1.293a4.37 4.37 0 0 0-3.065-1.183 4.53 4.53 0 0 0-4.027 2.5l1.502 1.171a2.715 2.715 0 0 1 2.55-1.875z",
    fill: "#EA4335"
  })), /*#__PURE__*/React.createElement("svg", {
    className: "payment-icon",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    width: "38",
    height: "24",
    viewBox: "0 0 38 24",
    "aria-labelledby": "pi-klarna"
  }, /*#__PURE__*/React.createElement("title", {
    id: "pi-klarna"
  }, "Klarna"), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z",
    fill: "#FFB3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32",
    fill: "#FFB3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.117 13.184c-.487 0-.882.4-.882.892 0 .493.395.893.882.893.488 0 .883-.4.883-.893a.888.888 0 00-.883-.892zm-2.903-.69c0-.676-.57-1.223-1.274-1.223-.704 0-1.274.547-1.274 1.222 0 .675.57 1.223 1.274 1.223.704 0 1.274-.548 1.274-1.223zm.005-2.376h1.406v4.75h-1.406v-.303a2.446 2.446 0 01-1.394.435c-1.369 0-2.478-1.122-2.478-2.507 0-1.384 1.11-2.506 2.478-2.506.517 0 .996.16 1.394.435v-.304zm-11.253.619v-.619h-1.44v4.75h1.443v-2.217c0-.749.802-1.15 1.359-1.15h.016v-1.382c-.57 0-1.096.247-1.378.618zm-3.586 1.756c0-.675-.57-1.222-1.274-1.222-.703 0-1.274.547-1.274 1.222 0 .675.57 1.223 1.274 1.223.704 0 1.274-.548 1.274-1.223zm.005-2.375h1.406v4.75h-1.406v-.303A2.446 2.446 0 0114.99 15c-1.368 0-2.478-1.122-2.478-2.507 0-1.384 1.11-2.506 2.478-2.506.517 0 .997.16 1.394.435v-.304zm8.463-.128c-.561 0-1.093.177-1.448.663v-.535H22v4.75h1.417v-2.496c0-.722.479-1.076 1.055-1.076.618 0 .973.374.973 1.066v2.507h1.405v-3.021c0-1.106-.87-1.858-2.002-1.858zM10.465 14.87h1.472V8h-1.472v6.868zM4 14.87h1.558V8H4v6.87zM9.45 8a5.497 5.497 0 01-1.593 3.9l2.154 2.97H8.086l-2.341-3.228.604-.458A3.96 3.96 0 007.926 8H9.45z",
    fill: "#0A0B09",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("svg", {
    className: "payment-icon",
    viewBox: "0 0 38 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    width: "38",
    height: "24",
    "aria-labelledby": "pi-master"
  }, /*#__PURE__*/React.createElement("title", {
    id: "pi-master"
  }, "Mastercard"), /*#__PURE__*/React.createElement("path", {
    opacity: ".07",
    d: "M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EB001B",
    cx: "15",
    cy: "12",
    r: "7"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F79E1B",
    cx: "23",
    cy: "12",
    r: "7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F00",
    d: "M22 12c0-2.4-1.2-4.5-3-5.7-1.8 1.3-3 3.4-3 5.7s1.2 4.5 3 5.7c1.8-1.2 3-3.3 3-5.7z"
  })), /*#__PURE__*/React.createElement("svg", {
    className: "payment-icon",
    viewBox: "0 0 38 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "38",
    height: "24",
    role: "img",
    "aria-labelledby": "pi-paypal"
  }, /*#__PURE__*/React.createElement("title", {
    id: "pi-paypal"
  }, "PayPal"), /*#__PURE__*/React.createElement("path", {
    opacity: ".07",
    d: "M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003087",
    d: "M23.9 8.3c.2-1 0-1.7-.6-2.3-.6-.7-1.7-1-3.1-1h-4.1c-.3 0-.5.2-.6.5L14 15.6c0 .2.1.4.3.4H17l.4-3.4 1.8-2.2 4.7-2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3086C8",
    d: "M23.9 8.3l-.2.2c-.5 2.8-2.2 3.8-4.6 3.8H18c-.3 0-.5.2-.6.5l-.6 3.9-.2 1c0 .2.1.4.3.4H19c.3 0 .5-.2.5-.4v-.1l.4-2.4v-.1c0-.2.3-.4.5-.4h.3c2.1 0 3.7-.8 4.1-3.2.2-1 .1-1.8-.4-2.4-.1-.5-.3-.7-.5-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M23.3 8.1c-.1-.1-.2-.1-.3-.1-.1 0-.2 0-.3-.1-.3-.1-.7-.1-1.1-.1h-3c-.1 0-.2 0-.2.1-.2.1-.3.2-.3.4l-.7 4.4v.1c0-.3.3-.5.6-.5h1.3c2.5 0 4.1-1 4.6-3.8v-.2c-.1-.1-.3-.2-.5-.2h-.1z"
  })), /*#__PURE__*/React.createElement("svg", {
    className: "payment-icon",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    viewBox: "0 0 38 24",
    width: "38",
    height: "24",
    "aria-labelledby": "pi-shopify_pay"
  }, /*#__PURE__*/React.createElement("title", {
    id: "pi-shopify_pay"
  }, "Shop Pay"), /*#__PURE__*/React.createElement("path", {
    opacity: ".07",
    d: "M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32z",
    fill: "#5A31F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.382 9.713c0 1.668-1.177 2.858-2.821 2.858h-1.549a.133.133 0 00-.12.08.127.127 0 00-.01.049v2.192a.129.129 0 01-.13.129h-1.084a.13.13 0 01-.13-.13V6.986a.127.127 0 01.08-.12.129.129 0 01.05-.01h2.9c1.637 0 2.814 1.19 2.814 2.858v-.001zm-1.352 0c0-.958-.658-1.658-1.55-1.658h-1.468a.13.13 0 00-.13.13v3.05a.127.127 0 00.038.092.129.129 0 00.092.038h1.468c.892.005 1.55-.695 1.55-1.652zm1.674 3.791a1.527 1.527 0 01.647-1.317c.423-.316 1.084-.48 2.055-.514l1.033-.036v-.303c0-.607-.41-.863-1.068-.863-.658 0-1.075.231-1.17.61a.127.127 0 01-.125.09h-1.022a.13.13 0 01-.126-.092.125.125 0 01-.004-.055c.152-.898.904-1.58 2.494-1.58 1.692 0 2.303.783 2.303 2.276v3.172a.13.13 0 01-.132.129h-1.03a.13.13 0 01-.13-.13v-.236a.096.096 0 00-.061-.091.1.1 0 00-.107.022c-.31.334-.808.575-1.607.575-1.175 0-1.95-.607-1.95-1.657zm3.735-.687v-.246l-1.339.07c-.705.036-1.115.326-1.115.816 0 .444.376.69 1.034.69.893 0 1.42-.48 1.42-1.33zm2.316 4.6v-.919a.13.13 0 01.049-.1.132.132 0 01.108-.027c.158.029.318.044.479.044a1.229 1.229 0 001.245-.876l.067-.211a.133.133 0 000-.088l-2.145-5.471a.13.13 0 01.06-.165.13.13 0 01.062-.015h1.04a.132.132 0 01.123.085l1.456 3.859a.131.131 0 00.125.088.133.133 0 00.125-.088l1.265-3.848a.13.13 0 01.126-.09h1.076a.134.134 0 01.132.116.134.134 0 01-.008.063l-2.295 6.076c-.528 1.413-1.433 1.773-2.43 1.773a1.959 1.959 0 01-.561-.066.132.132 0 01-.1-.14h.001zM8.57 6.4a5.363 5.363 0 00-3.683 1.427.231.231 0 00-.029.31l.618.839a.236.236 0 00.362.028 3.823 3.823 0 012.738-1.11c2.12 0 3.227 1.584 3.227 3.15 0 1.7-1.163 2.898-2.835 2.921-1.292 0-2.266-.85-2.266-1.974a1.908 1.908 0 01.713-1.48.231.231 0 00.033-.324l-.65-.815a.236.236 0 00-.339-.034 3.43 3.43 0 00-.942 1.183 3.39 3.39 0 00-.337 1.47c0 1.935 1.655 3.452 3.775 3.464h.03c2.517-.032 4.337-1.884 4.337-4.415 0-2.247-1.667-4.64-4.752-4.64z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("svg", {
    className: "payment-icon",
    viewBox: "0 0 38 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    width: "38",
    height: "24",
    "aria-labelledby": "pi-visa"
  }, /*#__PURE__*/React.createElement("title", {
    id: "pi-visa"
  }, "Visa"), /*#__PURE__*/React.createElement("path", {
    opacity: ".07",
    d: "M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3 10.1H28c-.4 1-.7 1.5-1 3h1.9c-.3-1.5-.3-2.2-.6-3zm2.9 5.9h-1.7c-.1 0-.1 0-.2-.1l-.2-.9-.1-.2h-2.4c-.1 0-.2 0-.2.2l-.3.9c0 .1-.1.1-.1.1h-2.1l.2-.5L27 8.7c0-.5.3-.7.8-.7h1.5c.1 0 .2 0 .2.2l1.4 6.5c.1.4.2.7.2 1.1.1.1.1.1.1.2zm-13.4-.3l.4-1.8c.1 0 .2.1.2.1.7.3 1.4.5 2.1.4.2 0 .5-.1.7-.2.5-.2.5-.7.1-1.1-.2-.2-.5-.3-.8-.5-.4-.2-.8-.4-1.1-.7-1.2-1-.8-2.4-.1-3.1.6-.4.9-.8 1.7-.8 1.2 0 2.5 0 3.1.2h.1c-.1.6-.2 1.1-.4 1.7-.5-.2-1-.4-1.5-.4-.3 0-.6 0-.9.1-.2 0-.3.1-.4.2-.2.2-.2.5 0 .7l.5.4c.4.2.8.4 1.1.6.5.3 1 .8 1.1 1.4.2.9-.1 1.7-.9 2.3-.5.4-.7.6-1.4.6-1.4 0-2.5.1-3.4-.2-.1.2-.1.2-.2.1zm-3.5.3c.1-.7.1-.7.2-1 .5-2.2 1-4.5 1.4-6.7.1-.2.1-.3.3-.3H18c-.2 1.2-.4 2.1-.7 3.2-.3 1.5-.6 3-1 4.5 0 .2-.1.2-.3.2M5 8.2c0-.1.2-.2.3-.2h3.4c.5 0 .9.3 1 .8l.9 4.4c0 .1 0 .1.1.2 0-.1.1-.1.1-.1l2.1-5.1c-.1-.1 0-.2.1-.2h2.1c0 .1 0 .1-.1.2l-3.1 7.3c-.1.2-.1.3-.2.4-.1.1-.3 0-.5 0H9.7c-.1 0-.2 0-.2-.2L7.9 9.5c-.2-.2-.5-.5-.9-.6-.6-.3-1.7-.5-1.9-.5L5 8.2z",
    fill: "#142688"
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "footerEnd"
  }, /*#__PURE__*/React.createElement("div", {
    className: "copyrightText"
  }, "Copyright \xA92024 TLF Apparel | All Rights Reserved | Redefine Impossible"), /*#__PURE__*/React.createElement("div", {
    className: "policyContainer"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
    className: "policyOpt",
    href: "https://helpdesk.tlfapparel.com/hc/en-us/articles/4411116828813-Refund-Policy"
  }, "Refund Policy")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
    className: "policyOpt",
    href: "/pages/accessibility"
  }, "Accessibility")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
    className: "policyOpt",
    href: "https://terms.pscr.pt/legal/shop/tlfapparel/privacy_policy"
  }, "Privacy Policy")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
    className: "policyOpt",
    href: "https://terms.pscr.pt/legal/shop/tlfapparel/terms_of_service"
  }, "Terms and Conditions")))));
}
const domContainerForReactFooter = document.querySelector('#reactFooter');
const rootForReactFooter = ReactDOM.createRoot(domContainerForReactFooter);
rootForReactFooter.render( /*#__PURE__*/React.createElement(ReactFooter, null));
